module.exports = __webpack_public_path__ + "img/logo.acdb677e.svg";